// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryMetadata.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var extendObservable = require('mobx').extendObservable;
  var trackable = require('share/tracking/Izenda.Trackable');
  var uiState = require('logic/Izenda.UiState');

  const { uniqueId, assign, omit } = require('lodash/fp');
  function CategoryMetadata(item) {
    var baseObject = {
      key: uniqueId(),
      id: null,
      tenantId: uiState.getTenantId() || null,
      name: '',
      modified: null
    };

    item = assign(baseObject, item || {});

    extendObservable(trackable(this), item);
  }

  /**
   * prepare json object for save request
   * @return {JSON} [description]
   */
  CategoryMetadata.prototype.prepareRequestJSON = function() {
    return omit(['isDirty', 'key'], this);
  };

  module.exports = CategoryMetadata;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.CategoryMetadata.js